module.exports = __webpack_public_path__ + "img/home-monthly-donation.f6b96500.png";